import React from 'react';
import CountryContainer from './components/CountryContainer';

const Countries = () => {
    return <CountryContainer />;
};

export default Countries;
